export default __webpack_public_path__ + "1672949c49500d115c49457fb5975649.svg";